module.exports = __webpack_public_path__ + "img/1535703166.828de018.jpg";